import { Types } from "@grandvisionhq/graphql";
const toEyeSide = (eyeSide) => {
  switch (eyeSide) {
    case "both":
      return Types.EyeSide.BOTH;
    case "left":
      return Types.EyeSide.LEFT;
    case "right":
    default:
      return Types.EyeSide.RIGHT;
  }
};
const mapContactLensesLineItem = ({
  sku,
  quantity,
  typeDetails
}) => {
  const {
    eyeSide: _eyeSide,
    prescriptionExpiryDate,
    externalOptician,
    contactLensPrescription,
    isSubscription,
    subscriptionDetails,
    segments
  } = typeDetails;
  const eyeSide = toEyeSide(_eyeSide);
  return {
    sku,
    quantity: quantity ?? 1,
    lineItemType: Types.LineItemType.CONTACTLENSES,
    typeDetails: {
      eyeSide,
      prescriptionExpiryDate,
      externalOptician,
      contactLensPrescription,
      isSubscription,
      subscriptionDetails,
      segments
    }
  };
};
export {
  mapContactLensesLineItem
};
//# sourceMappingURL=contact-lenses.js.map
